import { cn } from '@/lib/utils';

// D-012: brand mark comes from the design system's Logo component (`mark` variant — a monogram
// badge), not a static raster asset. Mapped from design_system/components/brand/Logo.jsx's
// variant="mark" path: inline "C" monogram on a product-colored circular field. Only the `mark`
// variant is implemented here since it's the only one Nova currently consumes (the TopBar product
// icon); the full "CCT" wordmark variants (black/green/white) can be added when a consumer needs
// them.
const MARK_PATHS = [
  'M91.9,10.99h-16.25c-7.26,0-13.14,5.89-13.14,13.15v29.39h42.54v-29.39c0-7.26-5.89-13.15-13.15-13.15',
  'M19.97,66.67v101.33c0,7.26,5.89,13.15,13.14,13.15h29.39V53.52h-29.39c-7.26,0-13.14,5.89-13.14,13.15',
  'M147.59,96.06v-29.39c0-7.26-5.89-13.14-13.15-13.14h-29.39v42.54h42.54Z',
  'M147.59,168v-29.39h-42.54v42.54h29.39c7.26,0,13.15-5.89,13.15-13.15',
  'M75.65,223.68h16.25c7.26,0,13.14-5.89,13.14-13.15v-29.39h-42.54v29.39c0,7.26,5.89,13.15,13.15,13.15',
] as const;

interface LogoProps {
  className?: string;
}

/** CCT monogram badge — white "C" on the product-brand field (`--primary`, currently green). */
export function Logo({ className }: Readonly<LogoProps>) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-primary',
        className,
      )}
      aria-hidden
    >
      <svg viewBox="14 4 140 226" className="h-[58%] w-[52%]">
        {MARK_PATHS.map((d) => (
          <path key={d} d={d} fill="var(--color-primary-foreground)" />
        ))}
      </svg>
    </span>
  );
}
